import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface EarningsSummaryProps {
  thisMonth?: string;
  lastMonth?: string;
  totalEarnings?: string;
  pendingWithdrawals?: string;
}

const EarningsSummary = ({
  thisMonth = '$0.00',
  lastMonth = '$0.00',
  totalEarnings = '$0.00',
  pendingWithdrawals = '$0.00',
}: EarningsSummaryProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Earnings Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-sm">This Month</span>
            <span className="font-bold">{thisMonth}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm">Last Month</span>
            <span className="font-bold">{lastMonth}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm">Total Earnings</span>
            <span className="font-bold">{totalEarnings}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm">Pending Withdrawals</span>
            <span className="font-bold">{pendingWithdrawals}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EarningsSummary;
